import { Contact } from 'data/contact/contact.types';
import {
  WithAuditDetails, AuditDetails, Operation
} from 'data/types';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';

export default function getContactDataToSubmit(
  contact: Contact,
  originalContact: Contact | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): WithAuditDetails<Contact> {
  const contactBody: WithAuditDetails<Contact> = {
    data: {
      ...contact,
      fullname: contact.name
    },
  };

  let actionType = AuditActionType.CONTACT_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.CONTACT_EDIT;
    isEdit = true;
  }

  if (isAuditEnabled) {
    const auditDetails = getAuditDetails(
      isAuditEnabled,
      userId,
      userName,
      getAuditFieldInfo(contact, null, isEdit, originalContact),
      contact.name,
      AuditService.CONTACT,
      actionType,
    );
    contactBody.auditDetails = auditDetails as AuditDetails;
  }

  return contactBody;
}
